import { ScheduleWindow } from '../../model/ScheduleWindow';
import { Timing } from '../../model/schedulingModels/Timing';

export type TimingWindow = ScheduleWindow & {
  /** always 0 when not repeating */
  repeatIndex: number;

  /**
   *  Number of times an event is expected/required within window, defaults to 1
   *  https://www.hl7.org/fhir/datatypes-definitions.html#Timing.repeat.frequency
   */
  frequency: number;

  /**
   *  Maximum number of times an event is allowed within window, defaults to 1
   *  https://www.hl7.org/fhir/datatypes-definitions.html#Timing.repeat.frequencyMax
   */
  frequencyMax: number;
};

const from = (
  timing: Timing,
  { windowStart, windowReferenceTimestamp, windowEnd }: ScheduleWindow,
  repeatIndex: number,
): TimingWindow => ({
  windowStart,
  windowReferenceTimestamp,
  windowEnd,
  repeatIndex,
  frequency: timing?.repeat?.frequency ?? 1,
  frequencyMax: timing?.repeat?.frequencyMax ?? 1,
});

export const TimingWindow = {
  from,
};
